import ApplyConversationActionRequest from 'owa-service/lib/contract/ApplyConversationActionRequest';
import ApplyConversationActionResponseMessage from 'owa-service/lib/contract/ApplyConversationActionResponseMessage';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';

/**
 * Sends out the service request to apply conversation action
 * @param requestBody the request body
 * @returns a Promise that handles the service request response
 */
export default function applyConversationActionService(
    requestBody: ApplyConversationActionRequest,
    header = getJsonRequestHeader(),
    requestOptions?: RequestOptions
): Promise<ApplyConversationActionResponseMessage> {
    if (
        !requestBody ||
        !requestBody.ConversationActions ||
        requestBody.ConversationActions.length === 0
    ) {
        throw new Error('ApplyConversationAction requestBody is invalid!');
    }

    // The conversation action array should apply all the same action to all the elements so
    // taking the 1st element of the array should be enough to know which header to pass down
    requestOptions = requestOptions || {};

    const options: RequestOptions = {
        ...requestOptions,
    };

    const headers = options.headers ? new Headers(<Headers>options.headers) : new Headers();
    headers.set(
        'X-OWA-ActionSource',
        'ApplyConversationAction_' + requestBody.ConversationActions[0].Action
    );
    options.headers = headers;

    return applyConversationActionOperation(
        {
            Header: header,
            Body: requestBody,
        },
        options
    )
        .then(response => response.Body.ResponseMessages.Items[0])
        .catch(error => {
            return Promise.reject(error);
        });
}
